import BsBarChartLine from "./icons/Bs/BsBarChartLine";
import BsCameraVideo from "./icons/Bs/BsCameraVideo";
import BsChatDots from "./icons/Bs/BsChatDots";
import BsClock from "./icons/Bs/BsClock";
import FaLineChart from "./icons/Fa/FaChartLine";
import FaTv from "./icons/Fa/FaTv";
import Fa6RegularCircleUser from "./icons/Fa6/Fa6RegularCircleUser";
import LiaCalendarDay from "./icons/Lia/LiaCalendarDaySolid";
import MdCalendarMonth from "./icons/Md/MdCalendarMonth";
import MdiFileLinkOutline from "./icons/Md/MdFilePresent";
import MdOutlineAnnouncement from "./icons/Md/MdOutlineAnnouncement";
import MdOutlineAssignment from "./icons/Md/MdOutlineAssignment";
import MdOutlineCameraFront from "./icons/Md/MdOutlineCameraFront";
import MdOutlineSettings from "./icons/Md/MdOutlineSettings";
import MdOutlineWest from "./icons/Md/MdOutlineWest";
import { MdStickyNote2 } from "./icons/Md/MdStickyNote2";
import Subscriptions from "./icons/Subscriptions";
import { permissionsParser } from "../utils/permissionsParser";
import FaUser from "./icons/Fa/FaUser";
import MdBookGrey from "./icons/Md/MdBookGrey";
import MdOutlineRateReview from "./icons/Md/MdOutlineRateReview";
import ForbiddenIcon from "./ForbiddenIcon";

export const getUsedIconsList = (styles, item) => {
  const iconsList = {
    setting: <MdOutlineSettings size={24} style={styles} />,
    "my-classrooms": <MdOutlineCameraFront size={24} style={styles} />,
    "my-calender": <MdCalendarMonth size={24} style={styles} />,
    "back-arrow": <MdOutlineWest size={24} styles={styles} />,
    "barchat-icon": <BsBarChartLine size={24} styles={styles} />,
    "tv-icon": <FaTv size={24} styles={styles} />,
    "cctv-camera": <BsCameraVideo size={24} styles={styles} />,
    "notes-icon": <MdStickyNote2 size={24} styles={styles} />,
    "practice-icon": <MdOutlineAssignment size={24} styles={styles} />,
    "clock-icon": <BsClock size={24} styles={styles} />,
    "files-icon": <MdiFileLinkOutline size={24} />,
    "announcement-icon": <MdOutlineAnnouncement size={24} styles={styles} />,
    "discussion-icon": <BsChatDots size={24} styles={styles} />,
    "performance-icon": <FaLineChart size={24} styles={styles} />,
    "student-calender": <LiaCalendarDay size={24} styles />,
    "student-profile": <Fa6RegularCircleUser size={24} />,
    subscriptions: <Subscriptions size={24} />,
    users: <FaUser size={24} />,
    "Book-grey": <MdBookGrey size={24} />,
    "forbidden-icon": <ForbiddenIcon size={24} />,
    "review-icon": <MdOutlineRateReview size={24} styles={styles} />,
  };
  return iconsList[item];
};
//else if (notif?.notificationCategory === "") {
//   const link = `${txt}/myClassrooms/${notif?.classroomId}/discussions`;
//   setShow(false);
//   navigate(link);
// } else if (notif?.notificationCategory === "") {
//   const link = `${txt}/myClassrooms/${notif?.classroomId}/discussions/${notif?.data?.channelId}`;
//   setShow(false);
//   navigate(link);
// } else if (notif?.notificationCategory === "") {
//   const link = `${txt}/myClassrooms/${notif?.classroomId}/discussions/${notif?.data?.channelId}`;
//   setShow(false);
//   navigate(link);
// } else if (notif?.notificationCategory === "") {
//   const link = `${txt}/myClassrooms/${notif?.classroomId}/practice`;
//   setShow(false);
//   navigate(link);
// } else if (notif?.notificationCategory === "") {
//   const link = `${txt}/myClassrooms/${notif?.classroomId}/tests`;
//   setShow(false);
//   navigate(link);
// } else if (notif?.notificationCategory === "") {
//   const link = `${txt}/myClassrooms/${notif?.classroomId}/conceptvideos`;
//   setShow(false);
//   navigate(link);
// } else if (notif?.notificationCategory === "") {
//   const link = `${txt}/myClassrooms/${notif?.classroomId}/lecturenotes`;
//   setShow(false);
//   navigate(link);
// } else if (notif?.notificationCategory === "") {
//   const link = `${txt}/myClassrooms/${notif?.classroomId}/full-length-exams`;
//   setShow(false);
//   navigate(link);
// }
export const getUsedNotificationIconsList = (styles, item) => {
  const iconsList = {
    conceptVideoAdded: <BsCameraVideo size={24} styles={styles} />,
    lectureNoteAdded: <MdStickyNote2 size={24} styles={styles} />,
    practiceSetAdded: <MdOutlineAssignment size={24} styles={styles} />,
    fullLengthExamAdded: <BsClock size={24} styles={styles} />,
    fileAdded: <MdiFileLinkOutline size={24} />,
    newAnnouncement: <MdOutlineAnnouncement size={24} styles={styles} />,
    channelCreated: <BsChatDots size={24} styles={styles} />,
    channelAnswerAdded: <BsChatDots size={24} styles={styles} />,
    channelQuestionAdded: <BsChatDots size={24} styles={styles} />,
    liveclassRescheduled: <FaTv size={24} styles={styles} />,
    liveclassSuspended: <FaTv size={24} styles={styles} />,
    liveclassResumed: <FaTv size={24} styles={styles} />,
    testAdded: <MdCalendarMonth size={24} style={styles} />,
    liveclassReminder: <FaTv size={24} styles={styles} />,
    liveclassStarted: <FaTv size={24} styles={styles} />,
    ieltsAttemptSubmitted: <MdOutlineRateReview size={24} styles={styles} />,
    ieltsAttemptGraded: <MdOutlineRateReview size={24} styles={styles} />,
  };
  return iconsList[item];
};

//liveclassReminder
// liveclassStarted

// const modules = [
//   "Class Recordings",
//   "Users",
//   "Drip Settings",
//   "Ask a Doubt",
// ];

export const getStudentEndPoints = (
  classId,
  roleOfTheUser = "",
  isCreator = false,
  rolePermissions = []
) => {
  const subscriptionPermissions = permissionsParser(
    "Subscriptions",
    rolePermissions
  );
  const isStudent = roleOfTheUser === "Student";
  const studentsPermissions = permissionsParser("Students", rolePermissions);
  const settingsPermissions = permissionsParser("Classroom", rolePermissions);
  const txt = isStudent ? "/student" : "";

  if (roleOfTheUser === "Watcher") {
    return [
      {
        id: 1,
        icon: "back-arrow",
        text: "Back to My Classrooms",
        link: isStudent ? "/student/myClassrooms" : "/myClassrooms",
        value: "back-button",
      },
      {
        id: 2,
        icon: "barchat-icon",
        text: "Dashboard",
        link: `${txt}/myClassrooms/${classId}/dashboard`,
        value: "Dashboard",
      },
      {
        id: 11,
        icon: "student-profile",
        text: "Students",
        value: "Students",
        link: `/myClassrooms/${classId}/students`,
      },
    ];
  }

  const list = [
    {
      id: 1,
      icon: "back-arrow",
      text: "Back to My Classrooms",
      link: isStudent ? "/student/myClassrooms" : "/myClassrooms",
      value: "back-button",
    },
    {
      id: 2,
      icon: "barchat-icon",
      text: "Dashboard",
      link: `${txt}/myClassrooms/${classId}/dashboard`,
      value: "Dashboard",
    },
    {
      id: 3,
      icon: "tv-icon",
      text: "Live Classes & Recordings",
      link: `${txt}/myClassrooms/${classId}/liveclasses`,
      value: "Live Classes",
    },
    {
      id: 4,
      icon: "cctv-camera",
      text: "Concept Videos",
      link: `${txt}/myClassrooms/${classId}/conceptvideos`,
      value: "Concept Videos",
    },
    {
      id: 5,
      icon: "notes-icon",
      text: "Lecture Notes",
      link: `${txt}/myClassrooms/${classId}/lecturenotes`,
      value: "Lecture Notes",
    },
    {
      id: 6,
      icon: "practice-icon",
      text: "Practice",
      value: "Practice",
      link: `${txt}/myClassrooms/${classId}/practice`,
    },
    {
      id: 7,
      icon: "my-calender",
      text: "Topic-Wise Tests",
      value: "Topic-wise Tests",
      link: `${txt}/myClassrooms/${classId}/tests`,
    },
    {
      id: 8,
      icon: "clock-icon",
      text: "Full-Length Exams",
      value: "Full-Length Exams",
      link: `${txt}/myClassrooms/${classId}/full-length-exams`,
    },
    {
      id: 9,
      icon: "files-icon",
      text: "Files",
      value: "Files",
      link: `${txt}/myClassrooms/${classId}/files`,
    },
    {
      id: 16,
      icon: "announcement-icon",
      text: "Announcements",
      value: "Announcements",
      link: `${txt}/myClassrooms/${classId}/announcements`,
    },
    {
      id: 15,
      icon: "student-calender",
      text: "My Calender",
      value: "Calendar",
      link: `${txt}/myClassrooms/${classId}/calendar`,
    },
  ];
  if (
    !isStudent &&
    (subscriptionPermissions.view ||
      (subscriptionPermissions.view_own && isCreator))
  ) {
    list.push({
      id: 10,
      icon: "subscriptions",
      text: "Subscriptions",
      value: "Subscriptions",
      link: `/myClassrooms/${classId}/subscriptions`,
    });
  }

  if (
    !isStudent &&
    (studentsPermissions.view || (studentsPermissions.view_own && isCreator))
  ) {
    list.push({
      id: 11,
      icon: "student-profile",
      text: "Students",
      value: "Students",
      link: `/myClassrooms/${classId}/students`,
    });
  }
  if (
    !isStudent &&
    (settingsPermissions.view || settingsPermissions.view_own)
  ) {
    list.push({
      id: 12,
      icon: "setting",
      text: "Settings",
      value: "Settings",
      link: `/myClassrooms/${classId}/settings`,
    });
  }
  if (isStudent) {
    list.push({
      id: 13,
      icon: "performance-icon",
      text: "Performance Review",
      value: "Performance Review",
      link: `${txt}/${classId}/overall-performance`,
    });
  }

  if (!isStudent) {
    list.push({
      id: 17,
      icon: "review-icon",
      text: "Review Attempts",
      value: "Review Attempts",
      link: `/myClassrooms/${classId}/ielts-review`,
    });
  }

  list.push({
    id: 14,
    icon: "discussion-icon",
    text: "Discussions",
    value: "Discussions",
    link: `${txt}/myClassrooms/${classId}/discussions`,
  });

  return list;
};

export const MustIncludedSidebarItems = [
  "Students",
  "Dashboard",
  "back-button",
  "Subscriptions",
];

export const getMainScreenEndponts = (roleOfTheUser, rolePermissions = []) => {
  const isStudent = roleOfTheUser === "Student";
  const usersPermissions = permissionsParser("Users", rolePermissions);
  const classroomsPermissions = permissionsParser("Classroom", rolePermissions);
  const courseworkPermissions = permissionsParser(
    "Coursework",
    rolePermissions
  );

  const list = [];

  // Add Admin Dashboard link for admin users
  if (
    roleOfTheUser === "admin" ||
    roleOfTheUser === "Root" ||
    roleOfTheUser === "Super Admin"
  ) {
    list.push({
      id: 0,
      icon: "barchat-icon",
      text: "Admin Dashboard",
      value: "Admin Dashboard",
      link: "/admin/dashboard",
    });
  }

  if (isStudent) {
    list.push({
      id: 1,
      icon: "my-classrooms",
      text: "My Classrooms",
      value: "My Classrooms",
      link: `${isStudent ? "/student" : ""}/myClassrooms`,
    });
  }

  if (
    !isStudent &&
    (classroomsPermissions?.view || classroomsPermissions?.view_own)
  ) {
    list.push({
      id: 1,
      icon: "my-classrooms",
      text: "My Classrooms",
      value: "My Classrooms",
      link: `${isStudent ? "/student" : ""}/myClassrooms`,
    });
  }
  if (roleOfTheUser === "Root") {
    list.push({
      id: 4,
      icon: "tv-icon",
      text: "Live Classes & Recordings",
      link: `/super-admin/liveclasses`,
      value: "Live Classes",
    });
  }
  // if (roleOfTheUser === "Root") {
  //   list.push({
  //     id: 5,
  //     icon: "tv-icon",
  //     text: "Admin Panel",
  //     link: `/admin/dashboard`,
  //     value: "Admin Dashboard",
  //   });
  // }
  if (!isStudent && usersPermissions?.view) {
    list.push({
      id: 2,
      icon: "users",
      text: "Users",
      value: "Users",
      link: `/users-management/manage-students`,
    });
    // list.push({
    //   id: 4,
    //   icon: "users",
    //   text: "Old Users",
    //   value: "Old Users",
    //   link: `/users/students`,
    // });
  }
  if (
    !isStudent &&
    (courseworkPermissions?.view || courseworkPermissions?.view_own)
  ) {
    list.push({
      id: 3,
      icon: "Book-grey",
      text: "COURSEWORK",
      value: "COURSEWORK",
      link: "/categories",
    });
  }

  list.push({
    id: 5,
    icon: "setting",
    text: "Settings",
    value: "Settings",
    link: `/generalSettings`,
  });

  return list;
};
